import styled from "styled-components";

export const Container = styled.div`
	margin: 1rem 0 0 0;
`;

export const ContainerRow = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
`;
